module.exports = "data:image/webp;base64,UklGRpgAAABXRUJQVlA4IIwAAADwBACdASoZABkAPok2lkelIyIhN/VYAKARCWIAnTKEhCARkG/dmyMxLMHPk/JnpAAA/vkYdgF25K0RfhNjUIcuCsLnZFn9MD8J/bOPy4i8Np+EkjIrK724FIbwx8G7OVDK2+kFOqairZVEw2E78v4Y3vjWVSOiQncUuDEdXMqFHJIuwLhXEt/RnAAAAA=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/color/deep_lagoon.webp
// module id = L6ht
// module chunks = 14